import { render, staticRenderFns } from "./EmployeeSignature.vue?vue&type=template&id=71ab66e4"
import script from "./EmployeeSignature.vue?vue&type=script&lang=js"
export * from "./EmployeeSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports